import type {ComponentProps, ReactNode, Ref} from "react";

import {IFieldState} from "../types";

export type TextInputBaseProps = ComponentProps<"div"> & {
    fieldState: IFieldState;
    children?: ReactNode;
    ref?: Ref<HTMLDivElement | null>;
};

export function TextInputBase(props: TextInputBaseProps) {
    const {fieldState, children, style, ref, ...rest} = props;

    return (
        <div
            ref={ref}
            style={{
                cursor: fieldState === "disabled" ? "inherit" : "text",
                ...style
            }}
            {...rest}
        >
            {children}
        </div>
    );
}
import type {ComponentProps, ReactNode, Ref} from "react";

import {IFieldState} from "../types";

export type TextInputBaseProps = ComponentProps<"div"> & {
    fieldState: IFieldState;
    children?: ReactNode;
    ref?: Ref<HTMLDivElement | null>;
};

export function TextInputBase(props: TextInputBaseProps) {
    const {fieldState, children, style, ref, ...rest} = props;

    return (
        <div
            ref={ref}
            style={{
                cursor: fieldState === "disabled" ? "inherit" : "text",
                ...style
            }}
            {...rest}
        >
            {children}
        </div>
    );
}
